module.exports = __webpack_public_path__ + "static/media/avenir-next-thin.ee917ba6.ttf";